<template>
  <div v-if="activated == true" style="height:100%; width:100%;display:contents;">
    <slot></slot>
  </div>
</template>

<script>

  var resolve = null;
  var reject = null;

  export default {
    name: "activator",
    components: {
    },
    props: {
      activated: {
        type: Boolean,
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      },
    },
    data() {
      return {
        resolve,
      };
    },
    methods: {
      activate() {
        if (this.disabled == true) {
          return new Promise((resolve, reject) => {
            reject();
          })
        }

        if (this.activated == true) {
          return new Promise((resolve, reject) => {
            resolve();
          })
        }
        this.activated = true;
        return new Promise((res, rej) => {
          this.resolve = res;
          this.reject = rej;
        })
      },
    },
    
    computed: {
      
    },
    watch: {
      
    },
    updated() {
      if (this.activated == true) {

        if (this.disabled == true) {
          this.reject();
        }

        this.resolve();
      }
    },
    mounted() {
  
    },
    created() {
      
    },
  };

</script>



// WEBPACK FOOTER //
// src/components/activator/activator.vue